var _excluded = ["children", "className"];
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { node, string } from 'prop-types';
import clsx from 'clsx';
import Toolbar, { toolbarClasses } from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
var StyledToolbar = styled(Toolbar)(function (_ref) {
  var _ref$theme = _ref.theme,
    palette = _ref$theme.palette,
    spacing = _ref$theme.spacing;
  var border = "1px solid ".concat(palette.divider);
  return _defineProperty({}, "&.".concat(toolbarClasses.root), {
    backgroundColor: palette.background.default,
    borderBottom: border,
    borderTop: border,
    boxSizing: 'border-box',
    display: 'flex',
    height: spacing(6),
    minHeight: spacing(6),
    padding: 0,
    width: '100%'
  });
});
var SovosToolbar = function SovosToolbar(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    rest = _objectWithoutProperties(_ref3, _excluded);
  return /*#__PURE__*/React.createElement(StyledToolbar, _extends({
    className: clsx('sovosToolbar', className)
  }, rest), children);
};
SovosToolbar.propTypes = {
  /**
   * Contents of the `SovosToolbar` component:
   *
   * - `SovosToolbarTitle`, `SovosToolbarActions`, `SovosToolbarBulkActions`,
   *   or `SovosToolbarDataGrouping`
   * - To add custom elements to the toolbar, wrap them in a `SovosToolbarGroup`
   */
  children: node.isRequired,
  /**
   * Extend the class name applied to the root element
   */
  className: string
};
SovosToolbar.baseComponent = {
  name: 'Toolbar',
  link: 'toolbar/'
};
export default SovosToolbar;